import SeatMap from './seat-map/theme';
import CancelOrder from './cancel-order/ui/theme';
import RefreshProblematicOrder from './order/refresh-problematic-order/ui/theme';
import UpdatePageModal from './update-page-modal/ui/theme';
import StartCheckIn from './start-check-in/ui/theme';
import PriceGraph from './price-graph/ui/theme';
import * as UpsaleItem from './upsale/ui/UpsaleItem/UpsaleItem.css';

import Refund from './refund/theme';
import Exchange from './exchange/theme';
import RefundServices from './refund-services/theme';

export default {
	SeatMap,
	Refund,
	Exchange,
	RefundServices,
	CancelOrder,
	RefreshProblematicOrder,
	UpdatePageModal,
	StartCheckIn,
	PriceGraph,
	Upsale: {
		UpsaleItem
	}
};
